import React from 'react';
import './endcap.scss';
import { NoProductsMessagePropType, NoProductsMessageDefaultPropType } from './Helper';

const ASSOCIATE_SVG = 'https://assets.homedepot-static.com/images/v1/plcc-associate-icon.svg';
const linkUrl = 'https://www.homedepot.com/b/Special-Values/N-5yc1vZ7';
const NoProductsMessage = ({ title, categoryName, url }) => {
  const hasUrl = (
    <div className="fallback-message__wrapper">
      <img className="fallback-message__icon" src={ASSOCIATE_SVG} height="1" width="1" alt="" />
      <div className="fallback-message__text">
        <div className="fallback-message__header">{title + ' are here!'}</div>
        <a href={url} className="fallback-message__link">{'Shop all ' + categoryName}</a>
      </div>
    </div>
  );

  const noUrl = (
    <div className="fallback-message__wrapper">
      <img className="fallback-message__icon" src={ASSOCIATE_SVG} height="1" width="1" alt="" />
      <div className="fallback-message__text">
        <div className="fallback-message__header">There&apos;s Even More Deals to Discover</div>
        <a href={linkUrl} className="fallback-message__link">Shop All Savings</a>
      </div>
    </div>
  );

  return url ? hasUrl : noUrl;
};

NoProductsMessage.propTypes = NoProductsMessagePropType;
NoProductsMessage.defaultProps = NoProductsMessageDefaultPropType;

export { NoProductsMessage };
